/**
 * Lazily injects the Google Identity Services script on demand.
 * Called from useGoogleIdentityInit so the script is only loaded on
 * routes that actually need it (login, register), saving ~130KB parse
 * cost on every authenticated page load.
 */

let injected = false;

export function loadGsiScript(): void {
  if (injected) return;
  if (document.querySelector('script[src*="accounts.google.com/gsi/client"]')) {
    injected = true;
    return;
  }

  injected = true;
  const script = document.createElement("script");
  script.src = "https://accounts.google.com/gsi/client";
  script.async = true;
  script.defer = true;
  script.dataset.useFedcmForPrompt = "true";
  document.head.appendChild(script);
}
